import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=220bed20&scoped=true"
import script from "./OrderReview.vue?vue&type=script&lang=js"
export * from "./OrderReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220bed20",
  null
  
)

export default component.exports